import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'magnific-popup/dist/magnific-popup.css';

export default () => {
  const $root = $('.popup');
  const $input = $root.find('.popup__input');
  const $inputPhone = $root.find('.popup__input--phone');
  const $inputPhoneError = $root.find('.popup__error-phone');
  const $form = $root.find('#callback-form');
  const $error = $form.find('.popup__error');
  const $checkbox = $form.find('.popup__check');

  // $('.js-open-popup').magnificPopup({
  //   type:'inline',
  //   midClick: true,
  //   mainClass: 'popup--callback',
  //   fixedContentPos: true,
  // });

  $input.on('input', (e) => {
    const $target = $(e.currentTarget);
    if($target.val().length > 0) {
      $target.addClass('not--empty');
    } else {
      $target.removeClass('not--empty');
    }
  });

  $form.on('submit', (e) => {
    e.preventDefault();
    const $inputs = $form.find('.popup__input');
    if($form.find('.popup__check').is(':checked') === true){
      if($inputPhone.val().length !== 16){
        $inputPhoneError.addClass('popup__error-phone--show');
      } else {
        $error.removeClass('popup__error--show');
        $inputPhoneError.removeClass('popup__error-phone--show');
        $.ajax({
          type: "post",
          url: $form.attr('action'),
          data: $form.serialize(),
          success: function (data) {
            $inputs.val('');
            $inputs.removeClass('not--empty');
            location.href = 'https://premium.estate/top-complex/thankyoupage';
          },
          error: function (data) {
            if(data.status === 500) {
              $('#recaptchaError').html(data.responseText);
            }
          }
        })
      }
    } else {
      $error.addClass('popup__error--show');
    }
  });

  $checkbox.on('change', () => {
    if($checkbox.is(':checked') === true) {
      $error.removeClass('popup__error--show');
    }
  });

  $inputPhone.on('input', () => {
    $inputPhoneError.removeClass('popup__error-phone--show');
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/popup/index.js